//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'ADDARTICLE',
  computed: {
    answers() {
      return [{
        label: this.$i18n.t('block-1.question'),
        title: true
      }, {
        label: this.$i18n.t('block-1.paragraph')
      }, {
        label: this.$i18n.t('block-1.paragraph2')
      }, {
        label: this.$i18n.t('block-2.question'),
        title: true
      }, {
        label: this.$i18n.t('block-2.paragraph')
      }, {
        label: this.$i18n.t('block-2.paragraph2')
      }];
    }

  }
};